<template>
  <div>
    <div class="ui form">
      <h3 class="ui dividing header">Выбор учебного плана</h3>
      <div class="three fields">
        <div class="nine wide field">
          <label>Специальность</label>
          <select @change="getEduProf(programm.edu_prog)"
                  class="ui fluid search selection dropdown fullText"
                  name="edu_prog"
                  v-model="programm.edu_prog">
            <option value="">Выберите специальность</option>
            <option v-for="option in select_options.edu_progs" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="three wide field">
          <label>Год</label>
          <select @change="getCurriculum(programm.edu_prog, programm.year, programm.edu_prof)"
                  class="ui fluid search selection dropdown"
                  name="year"
                  v-model="programm.year">
            <option value="">Год учебного плана</option>
            <option v-for="option in select_options.years" :value="option.id" :key="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="nine wide field">
          <label>Профиль</label>
          <select @change="getCurriculum(programm.edu_prog, programm.year, programm.edu_prof)"
                  id="edu_prof" class="ui fluid search selection dropdown"
                  name="edu_prof"
                  v-model="programm.edu_prof">
            <option value="">Выберите профиль</option>
            <option v-for="option in select_options.edu_profs" :value="option.id" :key="option.id">
              {{ option.id1c }} {{ option.name }}
            </option>
          </select>
        </div>
      </div>
      <div>
        <div class="two fields">
          <div class="twelve wide field">
            <label class="bold">Учебный план</label>
            <select id="curriculum"
                    @change="getMainInformation(programm.edu_prog, programm.edu_prof, programm.curriculum,)"
                    class="ui fluid search selection dropdown"
                    name="curriculum"
                    v-model="programm.curriculum">
              <option value="">Учебный план</option>
              <option v-for="option in select_options.curriculum" :value="option.id" :key="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="seven wide field">
            <label class="bold">Вид дисциплины</label>
            <select id="curriculum"
                    @change="mainText"
                    class="ui fluid search selection dropdown"
                    name="curriculum"
                    v-model="main_info.doc_type">
              <option>Вид дисциплины</option>
              <option :value="option" v-for="option in doc_types">
                {{ option }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <h3 class="ui dividing header">Использовать в качестве шаблона</h3>
    <div class="nine wide field">
      <label style="font-weight: bold">Заполнить на основании шаблона</label>
      <select @change="getRPG(programm.rpg_sample)"
              class="ui fluid search selection dropdown fullText"
              name="edu_prog"
              v-model="programm.rpg_sample">
        <option value="0">Без шаблона</option>
        <option v-for="option in select_options.rpg_samples" :value="option.id" :key="option.id">
          {{ option.name }}, Профиль: {{ option.profile}}
        </option>
      </select>
    </div>
    <div class="ui form" id="main" v-if="main">
      <h3 class="ui dividing header">Основная информация</h3>
      <div id="basis">
        <div class="inline fields">
          <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] !== '05'">
            <div class="ui right pointing large label">
              Направление подготовки
            </div>
            <input type="text" placeholder="Специальность" v-model="main_info.speciality" disabled="true">
          </div>
          <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] === '05'">
            <div class="ui right pointing large label">
              Специальность
            </div>
            <input type="text" placeholder="Специальность" v-model="main_info.speciality" disabled="true">
          </div>
          <div class="five wide field">
            <div class="ui right pointing large label">
              Квалификация выпускника
            </div>
            <input type="text" placeholder="Квалификация" v-model="main_info.quality" disabled="true">
          </div>
        </div>
        <div class="inline fields">
          <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] !== '05'">
            <div class="ui right pointing large label">
              Профиль
            </div>
            <input type="text" placeholder="Профиль" v-model="main_info.profile" disabled="true">
          </div>
          <div class="seven wide field" v-if="main_info.speciality_code.split('.')[1] === '05'">
            <div class="ui right pointing large label">
              Специализация
            </div>
            <input type="text" placeholder="Профиль" v-model="main_info.profile" disabled="true">
          </div>
          <div class="four wide field">
            <div class="ui right pointing large label">
              Год набора
            </div>
            <input type="text" placeholder="Год набора" v-model="main_info.year" disabled="true">
          </div>
          <div class="three wide field">
            <div class="ui right pointing large label">
              Форма обучения
            </div>
            <input type="text" placeholder="Форма обучения" v-model="main_info.edu_form" disabled="true">
          </div>
        </div>
        <div class="ui equal width form">
          <div class="inline fields">
            <div class="four wide field">
              <div class="ui right pointing large label">
                И.О.Фамилия
              </div>
              <input type="text" placeholder="И.О.Фамилия" v-model="initial" disabled="true">
            </div>
            <div class="four wide field">
              <div class="ui right pointing large label">
                Должность
              </div>
              <input type="text" placeholder="Должность" v-model="main_info.creator.position">
            </div>
            <div class="four wide field">
              <div class="ui right pointing large label">
                Ученая степень
              </div>
              <input type="text" placeholder="Ученая степень" v-model="main_info.creator.title">
            </div>
          </div>
        </div>
        <div class="two fields">
          <div class="six wide field">
            <label>Выпускающая кафедра</label>
            <select class="ui fluid search selection dropdown"
                    name="grad_dep"
                    v-model="main_info.grad_dep">
              <option value="">Выпускающая кафедра</option>
              <option v-for="option in select_options.departments" :value="option.name" :key="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="six wide field">
            <label>Заведующий выпускающей кафедры</label>
            <div class="ui input">
              <input type="text" placeholder="Заведующий выпускающей кафедры" v-model="provisor">
            </div>
          </div>
        </div>
        <div class="three fields">
          <div class="five wide field">
            <label>Факультет</label>
            <div class="ui input">
              <input type="text" placeholder="Факультет" v-model="main_info.facility">
            </div>
          </div>
          <div class="five wide field">
            <label>Обеспечивающая кафедра</label>
            <div class="ui input">
              <input type="text" placeholder="Обеспечивающая кафедра" v-model="main_info.department">
            </div>
          </div>
          <div class="five wide field">
            <label>
              Заведующий кафедрой
            </label>
            <div class="ui input">
              <input type="text" placeholder="Заведующий кафедрой" v-model="main_info.dep_manager">
            </div>
          </div>
        </div>
        <div class="two fields">
          <div class="four wide field">
            <label>Дата заседания кафедры</label>
            <div class="ui input">
              <input type="text" placeholder="Дата заседания кафедры" v-model="main_info.approval_date">
            </div>
          </div>
          <div class="two wide field">
            <label>Протокол №</label>
            <div class="ui input">
              <input type="text" placeholder="Протокол №" v-model="main_info.protocol_num">
            </div>
          </div>
        </div>
        <div><textarea rows="2" v-model="main_info.basis"></textarea></div>
        <div class="two fields">
          <div class="four wide field">
            <label>Дата утверждения приказа</label>
            <div class="ui input">
              <input type="text" placeholder="Дата утверждения приказа" v-model="main_info.basis_date">
            </div>
          </div>
          <div class="two wide field">
            <label>№ Приказа</label>
            <div class="ui input">
              <input type="text" placeholder="№ Приказа" v-model="main_info.basis_num">
            </div>
          </div>
        </div>
      </div>
      <div v-if="main_info.doc_type === 'Государственная итоговая аттестация'">
        <h3 class="ui dividing header">1 ОБЩИЕ ПОЛОЖЕНИЯ</h3>
        <div>
          <h4>1.2 Виды деятельности выпускников и соответствующие им типы задач профессиональной деятельности:</h4>
          <h5>1.2.1 Виды деятельности выпускников</h5>
          <vue-editor v-model="actives_type.actives" :editor-toolbar="customToolbar"/>
          <h5>1.2.2 Типы задач профессиональной деятельности</h5>
          <vue-editor v-model="actives_type.tasks" :editor-toolbar="customToolbar"/>
          <h5>1.2.3. Требования к профессиональной подготовленности выпускника, необходимые для выполнения им задач профессиональной деятельности</h5>
          <div>
            <div class="ui form"><textarea rows="2" type="text" placeholder="Преамбула к компетенциям" v-model="text_info.preamble_comp"></textarea></div>
            <h4>а) Универсальные компетенции выпускников и индикаторы их достижения</h4>
            <table class="ui basic celled table">
              <thead>
              <tr class="active">
                <th width="20%"><div class="headTable">Категория (группа) универсальных компетенций</div></th>
                <th width="40%"><div class="headTable">Код и наименование универсальной компетенции</div></th>
                <th width="40%" colspan="2"><div class="headTable">Код и наименование индикатора достижения универсальной компетенции</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "comp in rpg_competitions.UK">
                <td>{{comp.info.cat}}</td>
                <td>
                  <select id="UKcompetition" class="ui fluid search selection dropdown"
                          name="UKcompetition"
                          v-model="comp.info">
                    <option value="">Выберите компетенцию</option>
                    <option v-for="option in UK" :value="option" :key="option.id">
                      {{ option.code }} {{ option.desc }}
                    </option>
                  </select>
                  <div class="ui section divider"></div>
                  <div>
                    {{ comp.info.code }} {{ comp.info.desc }}
                  </div>
                </td>
                <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
                <td width="2%">
                  <button class="ui icon button red stub" v-on:click="DelUKCompetition(rpg_competitions.UK.indexOf(comp))"><i class="trash icon"></i></button>
                </td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th colspan="4">
                  <button class="ui right floated small button positive" v-on:click="AddUKCompetition">
                    <i class="add icon"></i>
                    Добавить компетенцию
                  </button>
                </th>
              </tr>
              </tfoot>
            </table>
            <h4>б) Общепрофессиональные компетенции выпускников и индикаторы их достижения</h4>
            <table class="ui basic celled table" v-if="OPK.length">
              <thead>
              <tr class="active">
                <th width="20%"><div class="headTable">Категория (группа) общепрофессиональных компетенций</div></th>
                <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
                <th width="40%" colspan="2"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "comp in rpg_competitions.OPK_cat">
                <td>{{comp.info.cat}}</td>
                <td>
                  <select id="OPKCatcompetition" class="ui fluid search selection dropdown"
                          name="OPKCatcompetition"
                          v-model="comp.info">
                    <option value="">Выберите компетенцию</option>
                    <option v-for="option in OPK" :value="option" :key="option.id">
                      {{ option.code }} {{ option.desc }}
                    </option>
                  </select>
                  <div class="ui section divider"></div>
                  <div>
                    {{ comp.info.code }} {{ comp.info.desc }}
                  </div>
                </td>
                <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
                <td width="2%">
                  <button class="ui icon button red stub" v-on:click="DelOPKCatCompetition(rpg_competitions.OPK_cat.indexOf(comp))"><i class="trash icon"></i></button>
                </td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th colspan="4">
                  <button class="ui right floated small button positive" v-on:click="AddOPKCatCompetition">
                    <i class="add icon"></i>
                    Добавить компетенцию
                  </button>
                </th>
              </tr>
              </tfoot>
            </table>
            <table class="ui basic celled table" v-if="!OPK.length">
              <thead>
              <tr class="active">
                <th width="40%"><div class="headTable">Код и наименование общепрофессиональной компетенции</div></th>
                <th width="60%" colspan="2"><div class="headTable">Код и наименование индикатора достижения общепрофессиональной компетенции</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "comp in rpg_competitions.OPK">
                <td><div class="ui form"><textarea rows="10" type="text" placeholder="Код и наименование общепрофессиональной компетенции" v-model="comp.name"></textarea></div></td>
                <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
                <td width="2%">
                  <button class="ui icon button red stub" v-on:click="DelOPKCompetition(rpg_competitions.OPK.indexOf(comp))"><i class="trash icon"></i></button>
                </td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th colspan="3">
                  <button class="ui right floated small button positive" v-on:click="AddOPKCompetition">
                    <i class="add icon"></i>
                    Добавить компетенцию
                  </button>
                </th>
              </tr>
              </tfoot>
            </table>
            <h4>в) Профессиональные компетенции выпускников и индикаторы их достижения</h4>
            <table class="ui basic celled table">
              <thead>
              <tr class="active">
                <th width="40%"><div class="headTable">Код и наименование профессиональной компетенции</div></th>
                <th width="60%" colspan="2"><div class="headTable">Код и наименование индикатора достижения профессиональной компетенции</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "comp in rpg_competitions.PK">
                <td><div class="ui form"><textarea rows="10" type="text" placeholder="Код и наименование профессиональной компетенции" v-model="comp.name"></textarea></div></td>
                <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
                <td width="2%">
                  <button class="ui icon button red stub" v-on:click="DelPKCompetition(rpg_competitions.PK.indexOf(comp))"><i class="trash icon"></i></button>
                </td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th colspan="3">
                  <button class="ui right floated small button positive" v-on:click="AddPKCompetition">
                    <i class="add icon"></i>
                    Добавить компетенцию
                  </button>
                </th>
              </tr>
              </tfoot>
            </table>
            <h4>г) Дополнительные профессиональные компетенции выпускников и индикаторы их достижения</h4>
            <table class="ui basic celled table">
              <thead>
              <tr class="active">
                <th width="40%"><div class="headTable">Код и наименование дополнительной профессиональной компетенции</div></th>
                <th width="60%" colspan="2"><div class="headTable">Код и наименование индикатора достижения дополнительной профессиональной компетенции</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "comp in rpg_competitions.DPK">
                <td><div class="ui form"><textarea rows="10" type="text" placeholder="Код и наименование дополнительной профессиональной компетенции" v-model="comp.name"></textarea></div></td>
                <td><vue-editor v-model="comp.text" :editor-toolbar="customContentToolbar"/></td>
                <td width="2%">
                  <button class="ui icon button red stub" v-on:click="DelDPKCompetition(rpg_competitions.DPK.indexOf(comp))"><i class="trash icon"></i></button>
                </td>
              </tr>
              </tbody>
              <tfoot>
              <tr>
                <th colspan="3">
                  <button class="ui right floated small button positive" v-on:click="AddDPKCompetition">
                    <i class="add icon"></i>
                    Добавить компетенцию
                  </button>
                </th>
              </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <h3 class="ui dividing header">2 ТРЕБОВАНИЯ К ВЫПУСКНОЙ КВАЛИФИКАЦИОННОЙ РАБОТЕ</h3>
        <h4>2.2. Структура выпускной квалификационной работы и требования к ее содержанию</h4>
        <vue-editor v-model="text_info.structure" :editor-toolbar="customToolbar"/>
        <h4>2.3 Примерная тематика и порядок утверждения тем выпускных квалификационных работ</h4>
        <vue-editor v-model="text_info.subject" :editor-toolbar="customToolbar"/>
        <h4>2.4 Учебно-методическое и информационное обеспечение</h4>
        <div>
          <h5>2.4.1 Рекомендуемая литература</h5>
          <vue-editor v-model="text_info.literature" :editor-toolbar="customToolbar"/>
          <h5>2.4.2 Программное обеспечение и Интернет-ресурсы</h5>
          <h5>Программное обеспечение</h5>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%" colspan="2"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "soft in software">
              <td>
                <select id="software" class="ui fluid search selection dropdown"
                        name="software"
                        v-model="soft.info">
                  <option value="">Выберите компетенцию</option>
                  <option v-for="option in select_options.software" :value="option" :key="option.id">
                    {{ option.name }}
                  </option>
                </select>
                <div class="ui section divider"></div>
                <div>
                  {{ soft.info.name }}
                </div>
              </td>
              <td>
                {{ soft.info.license }}
              </td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelSoftware(software.indexOf(soft))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddSoftware">
                  <i class="add icon"></i>
                  Добавить программное обеспечение
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h5>Интернет ресурсы</h5>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%" colspan="2"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "res in resources">
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Название" v-model="res.name"></textarea></div></td>
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Описание" v-model="res.desc"></textarea></div></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelResources(resources.indexOf(res))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddResources">
                  <i class="add icon"></i>
                  Добавить Интернет ресурс
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h4>2.4.3 Профессиональные базы данных и информационные справочные системы</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%" colspan="2"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "db in data_bases">
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Название" v-model="db.name"></textarea></div></td>
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Описание" v-model="db.desc"></textarea></div></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelDataBases(data_bases.indexOf(db))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddDataBases">
                  <i class="add icon"></i>
                  Добавить справочную систему
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
        </div>
        <h4>2.5 Порядок выполнения и представления в ГЭК выпускной квалификационной работы</h4>
        <vue-editor v-model="text_info.order_execution" :editor-toolbar="customToolbar"/>
        <h4>2.6 Порядок защиты выпускной квалификационной работы</h4>
        <vue-editor v-model="text_info.order_def" :editor-toolbar="customToolbar"/>
        <h4>2.7 Критерии выставления оценок (соответствия уровня подготовки выпускника требованиям ФГОС ВО) на основе выполнения и защиты им квалификационной работы </h4>
        <vue-editor v-model="text_info.criteria" :editor-toolbar="customToolbar"/>
        <div v-if="main_info.speciality_code === '40.03.01' || main_info.speciality_code === '41.03.01' || main_info.speciality_code === '41.04.01'">
          <h3 class="ui dividing header">3 ТРЕБОВАНИЯ К ВЫПУСКНИКУ, ПРОВЕРЯЕМЫЕ В ХОДЕ ГОСУДРАСТВЕННОГО ЭКЗАМЕНА</h3>
          <h4>3.1 Перечень основных учебных модулей – дисциплин образовательной программы или их разделов и вопросов, выносимых для проверки на государственном экзамене</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th>Дисциплина (раздел дисциплины)</th>
              <th colspan="2">Перечень вопросов</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "work in discipline">
              <td width="30%"><div class="ui form"><textarea rows="10" type="text" placeholder="Название" v-model="work.name"></textarea></div></td>
              <td width="68%"><vue-editor v-model="work.content" :editor-toolbar="customContentToolbar"/></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelDiscipline(discipline.indexOf(work))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddDiscipline">
                  <i class="add icon"></i>
                  Добавить дисциплину
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h4>3.2 Список рекомендуемой литературы</h4>
          <vue-editor v-model="text_info.literature_gos" :editor-toolbar="customToolbar"/>
          <h4>3.3 Критерии выставления оценок на государственном экзамене</h4>
          <vue-editor v-model="text_info.criteria_gos" :editor-toolbar="customToolbar"/>
          <h4>3.4 Порядок проведения экзамена</h4>
          <vue-editor v-model="text_info.order_examination" :editor-toolbar="customToolbar"/>
        </div>
      </div>
      <div v-else-if="main_info.doc_type === 'ПРОГРАММА ИТОГОВОЙ АТЕСТАЦИИ'">
        <h3 class="ui dividing header">1 Общие положения</h3>
        <textarea v-model="actives_type.actives"></textarea>
        <h3 class="ui dividing header">2 Нормативные документы </h3>
        <textarea v-model="actives_type.tasks" disabled="true" rows="15"></textarea>
        <h3 class="ui dividing header">3 Требования к подготовленной диссертации и её представлению</h3>
        <textarea v-model="text_info.structure" disabled="true" rows="100"></textarea>
      </div>
      <div v-else>
        <h3 class="ui dividing header">1 Общие положения</h3>
        <textarea v-model="actives_type.actives" disabled="true" rows="30"></textarea>
        <h3 class="ui dividing header">2 Нормативные документы </h3>
        <textarea v-model="actives_type.tasks" disabled="true" rows="10"></textarea>
        <h3 class="ui dividing header">3 Объем выполнения научных исследований</h3>
        <div>
          Научные исследования аспиранта – это самостоятельная работа, ориентированная на  получение индивидуального научного результата
        </div>
        <div>
          Объем научных исследований аспиранта определяется учебным планом на весь периода  обучения:
        </div>
        <div class="inline fields">
          <div class="nine wide field">
            Общая трудоемкость выполнения научных исследований составляет
          </div>
          <div  class="one wide">
            <input type="text" placeholder="Зачетных едениц" v-model="main_info.zet">
          </div>
          <div class="three wide field">
            зачетных единиц
          </div>
          <div class="one wide">
            <input type="text" placeholder="Академ часов" v-model="main_info.hour">
          </div>
          <div class="two wide field">
            (ак.ч.)
          </div>
        </div>
        <h3 class="ui dividing header">4 Этапы выполнения научных исследований</h3>
        <table class="ui basic celled table">
          <thead>
          <tr class="active">
            <th width="10%"><div class="headTable">Этапы</div></th>
            <th width="50%"><div class="headTable">Перечень работ по этапам </div></th>
            <th width="10%"><div class="headTable">Курс</div></th>
            <th width="30%"><div class="headTable">Форма</div></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for = "dis in discipline">
            <td colspan="4">
              <table class="ui basic celled table">
                <thead>
                <tr class="active">
                  <th colspan="5" width="5%"><div class="ui form"><input type="text" placeholder="Название" v-model="dis.name"></div></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for = "work in dis.work">
                  <td width="10%"><div class="ui form"><input type="text" placeholder="Этап" v-model="work.stage"></div></td>
                  <td width="50%"><vue-editor v-model="work.content" :editor-toolbar="customContentToolbar"/></td>
                  <td width="10%"><div class="ui form"><input type="text" placeholder="Курс" v-model="work.course"></div></td>
                  <td width="28%"><div class="ui form"><input type="text" placeholder="Форма контроля" v-model="work.control"></div></td>
                  <td width="2%">
                    <button class="ui icon button red stub" v-on:click="DelWork(discipline.indexOf(dis), dis.work.indexOf(work))"><i class="trash icon"></i></button>
                  </td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                  <th colspan="5">
                    <button class="ui right floated small button red stub" v-on:click="DelStage(discipline.indexOf(dis))">
                      <i class="trash icon"></i>
                      Удалить этап
                    </button>
                    <button class="ui right floated small button positive" v-on:click="AddWork(discipline.indexOf(dis))">
                      <i class="add icon"></i>
                      Добавить практику
                    </button>
                  </th>
                </tr>
                </tfoot>
              </table>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th colspan="4">
              <button class="ui right floated small button positive" v-on:click="AddStage">
                <i class="add icon"></i>
                Добавить этап
              </button>
            </th>
          </tr>
          </tfoot>
        </table>
        <h3 class="ui dividing header">5 Текущий контроль и промежуточная аттестация по этапам выполнения научного исследования</h3>
        <textarea v-model="text_info.structure" disabled="true" rows="10"></textarea>
        <h3>6 Учебно-методическое и информационное обеспечение выполнения плана научной деятельности</h3>
        <div>
          <h4>1 Рекомендуемая литература</h4>
          <vue-editor v-model="text_info.literature" :editor-toolbar="customToolbar"/>
          <h5>2 Программное обеспечение и Интернет-ресурсы</h5>
          <h5>Программное обеспечение</h5>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%" colspan="2"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "soft in software">
              <td>
                <select id="software" class="ui fluid search selection dropdown"
                        name="software"
                        v-model="soft.info">
                  <option value="">Выберите компетенцию</option>
                  <option v-for="option in select_options.software" :value="option" :key="option.id">
                    {{ option.name }}
                  </option>
                </select>
                <div class="ui section divider"></div>
                <div>
                  {{ soft.info.name }}
                </div>
              </td>
              <td>
                {{ soft.info.license }}
              </td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelSoftware(software.indexOf(soft))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddSoftware">
                  <i class="add icon"></i>
                  Добавить программное обеспечение
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h5>Интернет ресурсы</h5>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%" colspan="2"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "res in resources">
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Название" v-model="res.name"></textarea></div></td>
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Описание" v-model="res.desc"></textarea></div></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelResources(resources.indexOf(res))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddResources">
                  <i class="add icon"></i>
                  Добавить Интернет ресурс
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
          <h4>3 Профессиональные базы данных и информационные справочные системы</h4>
          <table class="ui basic celled table">
            <thead>
            <tr class="active">
              <th width="20%"><div class="headTable">Наименование</div></th>
              <th width="40%" colspan="2"><div class="headTable">Описание</div></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for = "db in data_bases">
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Название" v-model="db.name"></textarea></div></td>
              <td><div class="ui form"><textarea rows="2" type="text" placeholder="Описание" v-model="db.desc"></textarea></div></td>
              <td width="2%">
                <button class="ui icon button red stub" v-on:click="DelDataBases(data_bases.indexOf(db))"><i class="trash icon"></i></button>
              </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
              <th colspan="3">
                <button class="ui right floated small button positive" v-on:click="AddDataBases">
                  <i class="add icon"></i>
                  Добавить справочную систему
                </button>
              </th>
            </tr>
            </tfoot>
          </table>
        </div>
        <h3>7 Материально-техническое обеспечение выполнения плана научной деятельности</h3>
        <vue-editor v-model="text_info.subject" :editor-toolbar="customToolbar"/>
      </div>
      <div class="ui bottom large attached button positive" tabindex="0" v-on:click="PushToController">
        Сохранить
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { VueEditor } from "vue2-editor";
import competitionsMixin from "../mixins/competitionsMixin";
import dataRpgMixin from "../mixins/dataRpgMixin";
import computedMixin from "../mixins/computedMixin";
import dataMixin from "../mixins/dataMixin";
import tableOperationMixin from "../mixins/tableOperationMixin";
import getersMixin from "../mixins/getersMixin";
import _ from "lodash";

export default {
  name: "create_rpg",
  mixins: [competitionsMixin, dataMixin, dataRpgMixin, computedMixin, tableOperationMixin, getersMixin],
  components: { VueEditor },
  data: () => ({
    programm: {edu_prog: 0, year: 0, edu_prof: 0, curriculum: 0, rpg_sample: 0},
  }),
  computed: {
  },

  methods: {
    getMainInformation(edu_prog_id, edu_prof_id, curriculum_id) {
      if (curriculum_id != 0){
        axios({
            method: 'get',
            url: `/programms/get_main_info_rpg/${edu_prog_id}/${edu_prof_id}/${curriculum_id}`,
        }).then((response) => {
          this.main_info.speciality = response.data.speciality;
          this.main_info.speciality_code = response.data.speciality_code;
          if (this.no_profile.includes(edu_prog_id)){
            this.main_info.profile = "";
          }
          else{
            this.main_info.profile = response.data.profile;
          }
          this.main_info.quality = this.basis_info[response.data.speciality_code].quality;
          this.main_info.year = response.data.year;
          this.main_info.edu_form = response.data.edu_form;
          this.main_info.creator.fio = response.data.fio;
          this.main_info.creator.position = response.data.position;
          this.main_info.creator.title = response.data.title;
          this.main_info.facility = response.data.facility;
          this.main_info.department = response.data.department;
          this.main_info.dep_manager = response.data.dep_manager;
          this.main_info.basis_num = this.basis_info[response.data.speciality_code].basis_num;
          this.main_info.basis_date = this.basis_info[response.data.speciality_code].basis_date;
          this.main = true;
          this.basisText()
          this.getGraduatedDep(curriculum_id);
          this.aproval();
        }).catch((error) => {
          return error;
        });
      }
    },
    basisText(){
      if (this.main_info.speciality_code.split('.')[1] === '05'){
        this.main_info.basis = "Программа ГИА составлена на основании Федерального государственного образовательного стандарта ВО для специальности " + this.main_info.speciality + ", утвержденного приказом Министерства науки и высшего образования Российской Федерации"
      }
      else {
        this.main_info.basis = "Программа ГИА составлена на основании Федерального государственного образовательного стандарта ВО для направления подготовки " + this.main_info.speciality + ", утвержденного приказом " + this.ministry[0]
      }
      if (this.main_info.doc_type === "ПРОГРАММА ИТОГОВОЙ АТЕСТАЦИИ"){
        this.main_info.basis = "Программа итоговой аттестации  разработана в соответствии с федеральными государственными требованиями к структуре программ подготовки научных и научно-педагогических кадров в аспирантуре (адъюнктуре), условиям их реализации, срокам освоения " +
            "этих программ с учетом различных форм обучения, образовательных технологий и особенностей отдельных категорий  аспирантов (адъюнктов), утвержденными приказом Минобрнауки России от 20.10.2021 № 951, Положением о подготовке научных и научно-педагогических кадров в аспирантуре " +
            "(адъюнктуре), утвержденным Постановлением Правительства Российской Федерации"
      }
      if (this.main_info.doc_type === "ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ"){
        this.main_info.basis = "Программа научных исследований разработана в соответствии с федеральными государственными требованиями к структуре программ подготовки научных и научно-педагогических кадров в аспирантуре (адъюнктуре), условиям их реализации, срокам освоения этих программ " +
            "с учетом различных форм обучения, образовательных технологий и особенностей отдельных категорий  аспирантов (адъюнктов),  утвержденными приказом Минобрнауки России"
      }
    },
    mainText(){
      if (this.main_info.doc_type === "ПРОГРАММА ИТОГОВОЙ АТЕСТАЦИИ"){
        this.actives_type.actives = "\t\t1.1 Итоговая аттестация по  программе аспирантуры   по научной специальности " + this.main_info.speciality + " проводится в форме оценки диссертации на соответствие критериям, установленным Федеральным законом «О науке и государственной научно-технической политике» и «Положением о присуждении ученых степеней», утвержденным Постановлением Правительства Российской Федерации от 24.09.2013 № 842. \n" +
        "\t\tИтоговая аттестация является обязательной.\n" +
        "\t\t1.2 К итоговой аттестации допускается аспирант, полностью выполнивший индивидуальный план работы, в том числе подготовивший диссертацию к защите." +
        "\t\tВ случае досрочного выполнения аспирантом обязанностей по освоению программы аспирантуры и выполнению индивидуального плана работы при условии завершения работы над диссертацией и отсутствия академической задолженности по личному заявлению аспиранта, согласованному с его научным руководителем, в порядке, установленном локальным нормативным актом организации, аспиранту предоставляется возможность проведения досрочной итоговой аттестации.\n" +
        "\t\t1.3 К задачам итоговой аттестации относятся:" +
        "\t\t- оценка диссертации на соответствие критериям, установленным «Положением о присуждении ученых степеней», утвержденным Постановлением Правительства Российской Федерации от 24.09.2013 № 842;\n" +
        "\t\t- оценка уровня сформированных у выпускника необходимых знаний методологических и теоретических основ, современных технологий по соответствующему направлению исследований в рамках научной специальности; методики написания, правил оформления и порядка защиты диссертации; умений планировать и осуществлять научную (научно-исследовательскую) и научно-педагогическую деятельность; владения навыками написания и оформления научных отчетов, докладов, публикаций, диссертации в соответствии с установленными критериями.\n" +
        "\t\tОбщая трудоемкость итоговой аттестации составляет 6 зачетных единиц (216 академических часа)."

        this.actives_type.tasks = "\t\tНормативно-правовую базу для итоговой аттестации составляют:\n" +
        "\t\tФедеральный закон РФ от 29 декабря 2012 г. № 273-ФЗ «Об образовании в Российской Федерации» (с изменениями и дополнениями); \n" +
        "\t\tФедеральный закон РФ от 23 августа 1996 г. N 127-ФЗ «О науке и государственной научно-технической политике»; \n" +
        "\t\t«Положение о присуждении ученых степеней», утвержденное Постановлением Правительства Российской Федерации от 24.09.2013 № 842 «О порядке присуждения учёных степеней»; \n" +
        "\t\t«Положение о совете по защите диссертаций на соискание ученой степени кандидата наук, на соискание ученой степени доктора наук», утвержденным приказом  Министерства образования и науки Российской Федерации от 10.11.2017 № 1093 (с изменениями и дополнениями от 24.02.2021 и 07.06.2021); \n" +
        "\t\tГОСТ Р 7.0.11-2011. Национальный стандарт Российской Федерации. Система стандартов по информации, библиотечному и издательскому делу. Диссертация и автореферат диссертации. Структура и правила оформления (утв. приказом Федерального агентства по техническому регулированию и метрологии от 13.12.2011 № 811-ст); \n" +
        "\t\tГОСТ 7.32-2017. Межгосударственный стандарт. Система стандартов по информации, библиотечному и издательскому делу. Отчет о научно-исследовательской работе. Структура и правила оформления (введен в действие Приказом Росстандарта от 24.10.2017 № 1494-ст). \n"

        this.text_info.structure = "\t\t3.1 Подготовленная диссертация должна соответствовать критериям, установленным «Положением о присуждении ученых степеней», утвержденным Постановлением Правительства Российской Федерации от 24.09.2013 № 842:\n" +
            "\t\t- п. 9. Диссертация на соискание ученой степени кандидата наук должна быть научно-квалификационной работой, в которой содержится решение научной задачи, имеющей значение для развития соответствующей отрасли знаний, либо изложены новые научно обоснованные технические, технологические или иные решения и разработки, имеющие существенное значение для развития страны;\n" +
            "\t\t- п. 10. Диссертация должна быть написана автором самостоятельно, обладать внутренним единством, содержать новые научные результаты и положения, выдвигаемые для публичной защиты, и свидетельствовать о личном вкладе автора диссертации в науку. \n" +
            "\t\t3.2 В диссертации, имеющей прикладной характер, должны приводиться сведения о практическом использовании полученных автором диссертации научных результатов, а в диссертации, имеющей теоретический характер, ‒ рекомендации по использованию научных выводов. \n" +
            "\t\t3.3 Предложенные автором диссертации решения должны быть аргументированы, и оценены по сравнению с другими известными решениями; \n" +
            "\t\t- п. 11. Основные научные результаты диссертации должны быть опубликованы в рецензируемых научных изданиях;\n" +
            "\t\t- п. 12. Требования к рецензируемым изданиям и правила формирования их перечня устанавливаются Министерством науки и высшего образования Российской Федерации;\n" +
            "\t\t- п. 13. Количество публикаций, в которых излагаются основные научные результаты диссертации на соискание ученой степени кандидата наук, в рецензируемых изданиях должно быть:\n" +
            "\t\tв области искусствоведения и культурологии, социально-экономических, общественных и гуманитарных наук ‒ не менее 3;\n" +
            "\t\tв остальных областях ‒ не менее 2.\n" +
            "\t\t3.4 К публикациям, в которых излагаются основные научные результаты диссертации на соискание ученой степени, в рецензируемых изданиях приравниваются патенты на изобретения, патенты (свидетельства) на полезную модель, патенты на промышленный образец, патенты на селекционные достижения, свидетельства на программу для электронных вычислительных машин, базу данных, топологию интегральных микросхем, зарегистрированные в установленном порядке;\n" +
            "\t\t- п. 14. В диссертации соискатель ученой степени обязан ссылаться на автора и (или) источник заимствования материалов или отдельных результатов.\n" +
            "\t\tПри использовании в диссертации результатов научных работ, выполненных соискателем ученой степени лично и (или) в соавторстве, соискатель ученой степени обязан отметить в диссертации это обстоятельство.\n" +
            "\t\t3.5 Диссертация и автореферат диссертации оформляются в соответствии с требованиями, устанавливаемыми Министерством науки и высшего образования Российской Федерации. Диссертация и автореферат представляются на русском языке.\n" +
            "\t\t3.6 Общая структура и правила оформления диссертации и автореферата представлены в ГОСТ Р 7.0.11-2011 «Диссертация и автореферат диссертации. Структура и правила оформления»\n" +
            "\t\t3.7 В соответствии  с п. 30 «Положения о совете по защите диссертаций на соискание ученой степени кандидата наук, на соискание ученой степени доктора наук», утвержденным приказом Министерства образования и науки Российской Федерации от 10.11.2017 № 1093 (с изменениями и дополнениями от 24.02.2021 и 07.06.2021) диссертация оформляется в виде рукописи и имеет следующую структуру:\n" +
            "\t\tа) титульный лист;\n" +
            "\t\tб) оглавление;\n" +
            "\t\tв) текст диссертации, включающий в себя:\n" +
            "\t\tвведение;\n" +
            "\t\tосновную часть;\n" +
            "\t\tзаключение;\n" +
            "\t\tсписок литературы;\n" +
            "\t\tсписок научных публикаций, в которых изложены основные научные результаты диссертации).\n" +
            "\t\tТекст диссертации также может включать список сокращений и условных обозначений, словарь терминов, список иллюстративного материала, приложения.\n" +
            "\t\tВведение к диссертации включает в себя актуальность избранной темы, степень ее разработанности, объект и предмет исследования, цели и задачи, научную новизну, теоретическую и практическую значимость работы, методологию и методы диссертационного исследования, положения, выносимые на защиту, степень достоверности и апробацию результатов.\n" +
            "\t\tОсновная часть диссертации состоит из нескольких логически завершенных глав или разделов, которые могут разбиваться на параграфы или подразделы соответственно. Каждая из глав (разделов) посвящена решению одной из задач, сформулированных во введении, и заканчивается выводами, к которым пришел автор в результате проведенных исследований. Количество глав (разделов) определяется логикой диссертационного исследования, и, как правило, не менее четырех. Названия глав (разделов) должны быть краткими и точно отражать их основное содержание.\n" +
            "\t\tВ заключении диссертации излагаются итоги выполненного исследования – конкретные выводы по результатам исследования, в соответствии с поставленными задачами, представляющие собой решение этих задач; основной научный результат, полученный автором в соответствии с целью исследования (решение поставленной научной проблемы, получение/применение нового знания о предмете и объекте); рекомендации, перспективы дальнейшей разработки темы.\n" +
            "\t\t3.8 Объём автореферата ‒ до 1 авторского листа (16 стр. текста: формат А4, шрифт 14 пт, одинарный интервал). Для области гуманитарных наук объём автореферата может составлять до 1,5 авторского листа\n" +
            "\t\tВ автореферате диссертации излагаются основные идеи и выводы диссертации, показывается вклад автора в проведенное исследование, степень новизны и практическая значимость приведенных результатов исследований, приводится список публикаций автора диссертации, в которых отражены основные научные результаты диссертации.\n" +
            "\t\tСтруктура рукописи диссертации должна отражать логику диссертационного исследования и обеспечивать единство и взаимосвязь  его элементов.   Рекомендуемый  объём  диссертации – 100-150 стр. текста: формат А4, шрифт 14 пт, полуторный интервал. \n" +
            "\t\t3.9 Подготовленная диссертация представляется на выпускающую кафедру для оценки диссертации на соответствие критериям, установленных «Положением о присуждении ученых степеней»,    утвержденным    Постановлением  Правительства  Российской Федерации  от 24.09.2013 № 842 «О порядке присуждения учёных степеней» в сроки, предусмотренные индивидуальным планом, вместе с авторефератом диссертации и отзывом научного руководителя. \n" +
            "\t\t3.10 В отзыве научного руководителя дается оценка уровня сформированных у выпускника необходимых знаний методологических и теоретических основ, современных технологий по соответствующему направлению исследований в рамках научной специальности; методики написания, правил оформления и порядка защиты диссертации; умений планировать и осуществлять научную (научно-исследовательскую) и научно-педагогическую деятельность; владения навыками написания и оформления научных отчетов, докладов, публикаций, диссертации в соответствии с установленными критериями.\n" +
            "\t\t3.11 Представление аспирантом доклада по диссертации носит характер научной дискуссии и проходит в обстановке требовательности, принципиальности и соблюдения научной и педагогической этики.\n" +
            "\t\tПредставление и обсуждение доклада проводятся в следующем порядке:\n" +
            "\t\t– информация председателя заседания об аспиранте, теме работы, научном руководителе, рецензентах;\n" +
            "\t\t– выступление аспиранта с докладом (15-20 минут);\n" +
            "\t\t– вопросы, заданные участниками заседания по теме работы, и ответы на них;\n" +
            "\t\t– выступление научного руководителя с краткой характеристикой аспиранта;\n" +
            "\t\t– выступление рецензентов;\n" +
            "\t\t– ответ аспиранта на вопросы рецензентов;\n" +
            "\t\t– дискуссия, в которой может принять участие любой присутствующий на защите;\n" +
            "\t\t– обсуждение и объявление решения о соответствии диссертации критериям.\n" +
            "\t\t3.12 Аспиранту, успешно прошедшему итоговую аттестацию по программе аспирантуры, не позднее 30 календарных дней с даты её проведения выдаётся заключение и свидетельство об окончании аспирантуры.\n" +
            "\t\tВ заключении отражаются личное участие аспиранта в получении результатов, изложенных в диссертации, степень достоверности результатов проведенных аспирантом исследований, их новизна и практическая значимость, ценность научных работ аспиранта, соответствие диссертации требованиям, установленным «Положением о присуждении ученых степеней», утвержденным Постановлением Правительства Российской Федерации от 24.09.2013 № 842, научная специальность (научные специальности) и отрасль науки, которым соответствует диссертация, полнота изложения материалов диссертации в работах, принятых к публикации и (или) опубликованных аспирантом.\n" +
            "\t\tПорядок подготовки заключения  осуществляется в соответствии с локальными нормативными актами университета.\n" +
            "\t\t3.13 Аспирантам, получившим на итоговой аттестации неудовлетворительные результаты, выдается справка об освоении программ аспирантуры по образцу, устанавливаемому университетом, а также заключение, содержащее информацию о несоответствии диссертации критериям, установленным «Положением о присуждении ученых степеней», утвержденным Постановлением Правительства Российской Федерации от 24.09.2013 № 842.\n" +
            "\t\t3.14 В случае несогласия с результатами итоговой аттестации аспирант имеет право на апелляцию. Для этого необходимо лично не позднее следующего рабочего дня после  объявления результатов  итоговой аттестации подать в апелляционную комиссию в письменном виде апелляцию о  нарушении, по его мнению, установленной  процедуры проведения итоговой аттестации и (или) несогласия с результатами итоговой аттестации. \n" +
            "\t\tПри рассмотрении апелляции апелляционная комиссия выносит одно из следующих решений: \n" +
            "\t\t- об отклонении апелляции и сохранении результата итоговой аттестации; \n" +
            "\t\t- об удовлетворении апелляции и выставлении иного результата итоговой аттестации. \n" +
            "\t\tРешение апелляционной комиссии не позднее следующего рабочего дня передаётся председателю заседания. Решение апелляционной комиссии является окончательным и пересмотру не подлежит.\n"

        this.text_info.subject = ""
      }
      else if (this.main_info.doc_type === "ПРОГРАММА НАУЧНЫХ ИССЛЕДОВАНИЙ"){
        this.actives_type.actives = "\t\tВ рамках освоения программ аспирантуры аспирант под руководством научного руководителя осуществляет научную (научно-исследовательскую) деятельность с целью подготовки диссертации к защите.\n" +
            "\t\tВ рамках осуществления научной (научно-исследовательской) деятельности, аспирант решает научную задачу, имеющую значение для развития соответствующей отрасли науки, либо разрабатывает новые научно обоснованные технические, технологические или иные решения и разработки, имеющие существенное значение для развития страны.\n" +
            "\t\tПодготовка диссертации к защите включает в себя выполнение индивидуального плана научной деятельности, написание, оформление и представление диссертации для прохождения итоговой диссертации.\n" +
            "\t\tПлан научной деятельности является примерным и включает в себя план выполнения научного исследования, план подготовки диссертации, план подготовки публикаций, в которых излагаются основные научные результаты диссертации, прохождение промежуточной и итоговой аттестации, перечень этапов освоения научного компонента программы аспирантуры, распределение указанных этапов по курсам и форму контроля их выполнения. \n" +
            "\t\tПлан научной деятельности конкретного обучающегося утверждается в индивидуальном плане аспиранта,  требования к которому устанавливаются соответствующим локальным актом АмГУ. \n" +
            "\t\tВ рамках осуществления научной (научно-исследовательской) деятельности,  аспирант имеет право на:\n" +
            "\t\tа)подачу заявок на участие в научных дискуссиях, конференциях и симпозиумах и иных коллективных обсуждениях;\n" +
            "\t\tб)подачу заявок на участие в научном и научно-техническом сотрудничестве (стажировки, командировки, программы \"академической мобильности\");\n" +
            "\t\tв)участие в конкурсе на финансирование научных исследований за счет средств соответствующего бюджета, фондов поддержки научной, научно-технической, инновационной деятельности и иных источников, не запрещенных законодательством Российской Федерации;\n" +
            "\t\tг)доступ к информации о научных и научно-технических результатах, если она не содержит сведений, относящихся к государственной и иной охраняемой законом тайне;\n" +
            "\t\tд)публикацию в открытой печати научных и (или) научно-технических результатов, если они не содержат сведений, относящихся к государственной и иной охраняемой законом тайне.\n" +
            "\t\tПодготовка публикаций включает в себя написание и  оформление научных статей, в которых излагаются основные научные результаты диссертации и их подача в: \n" +
            "\t\tа) рецензируемые научные издания, т.е. в журналах, входящих в «Перечень рецензируемых научных изданий, в которых должны быть опубликованы основные результаты диссертации на соискание ученой степени кандидата наук, на соискание ученой степени доктора наук» (Перечень ВАК)\n" +
            "\t\tб) в научные издания, индексируемые в наукометрической базе данных Russian Science Citation Index (RSCI), а также подачу заявок на патенты на изобретения, полезные модели, промышленные образцы, селекционные достижения, свидетельства о государственной регистрации программ для электронных вычислительных машин, баз данных, топологий интегральных микросхем в случае выполнения прикладных исследовательских работ по диссертации.\n" +
            "\t\tКоличество публикаций, в которых излагаются основные научные результаты диссертации на соискание ученой степени кандидата наук, должно быть:\n" +
            "\t\t– в области искусствоведения и культурологии, социально-экономических, общественных и гуманитарных наук – не менее 3 научных статей в изданиях из Перечня ВАК и дополнительно к ним не менее 1 публикации в изданиях, индексируемых в международных базах данных;\n" +
            "\t\t– в остальных областях – не менее 2 научных статей в изданиях из Перечня ВАК и дополнительно к ним не менее 2 публикаций в изданиях, индексируемых в международных базах данных)."

        this.actives_type.tasks = "\t\tНормативно-правовую базу для итоговой аттестации составляют:\n" +
            "\t\tФедеральный закон РФ от 29 декабря 2012 г. № 273-ФЗ «Об образовании в Российской Федерации» (с изменениями и дополнениями); \n" +
            "\t\tФедеральный закон РФ от 23 августа 1996 г. N 127-ФЗ «О науке и государственной научно-технической политике»; \n" +
            "\t\t«Положение о присуждении ученых степеней», утвержденное Постановлением Правительства Российской Федерации от 24.09.2013 № 842 «О порядке присуждения учёных степеней»; \n" +
            "\t\t«Положение о совете по защите диссертаций на соискание ученой степени кандидата наук, на соискание ученой степени доктора наук», утвержденным приказом  Министерства образования и науки Российской Федерации от 10.11.2017 № 1093 (с изменениями и дополнениями от 24.02.2021 и 07.06.2021); \n"

        this.text_info.structure = "\t\tТекущий контроль успеваемости обеспечивает оценку хода этапов проведения научных исследований, освоения дисциплин (модулей), прохождения практики в соответствии с индивидуальным планом научной деятельности и индивидуальным учебным планом.\n" +
            "\t\tТекущий контроль успеваемости по этапам осуществления научной деятельности аспиранта проводится с участием научного руководителя.\n" +
            "\t\tПромежуточная аттестация аспирантов обеспечивает оценку результатов осуществления этапов научной (научно-исследовательской) деятельности, результатов освоения дисциплин (модулей), прохождения практики в соответствии с индивидуальным планом научной деятельности и индивидуальным учебным планом.\n" +
            "\t\tПромежуточная аттестация проводится 1 раз в год в форме годового отчета по итогам выполнения индивидуального плана научной деятельности (ИПНД) и индивидуального учебного плана (ИУП, предусмотренных индивидуальным планом работы (ИПР) аспиранта за соответствующий период, на заседании кафедры. Отчет первоначально  предоставляется научному руководителю для проверки. Научный руководитель обеспечивает контроль за своевременным выполнением аспирантом индивидуального плана научной деятельности, представляет отзыв о качестве, своевременности и успешности проведения аспирантом этапов научной (научно-исследовательской) деятельности.\n" +
            "\t\tФорма контроля по этапам выполнения  – зачет. \n" +
            "\t\tФормы и порядок проведения промежуточной аттестации осуществляется в соответствии с локальными нормативными актами Университета.\n"

        this.text_info.subject = ""
      }
      else {
        this.actives_type.actives = ""
        this.actives_type.tasks = ""
        this.text_info.structure = ""
        this.text_info.subject = ""
      }
    },
    getRPG(id) {
      if (id == 0 ){
        this.text_info ={structure: "", subject: "", order_execution: "", order_def: "", order_examination: "", criteria: "", criteria_gos: "", literature_gos: "", literature: "", preamble_comp: ""},
        this.software = [];
        this.resources = [];
        this.data_bases = [];
        this.discipline = [];
        this.actives_type = {actives: "", tasks: ""};
      }
      else {
        axios({
          method: 'get',
          url: `/programms/get_rpg/${id}`,
        }).then((response) => {
          this.text_info.structure = response.data.rpg.structure_old;
          this.text_info.subject = response.data.rpg.subject_old;
          this.text_info.order_execution = response.data.rpg.order_execution_old;
          this.text_info.order_def = response.data.rpg.order_def_old;
          this.text_info.order_examination = response.data.rpg.order_examination_old;
          this.text_info.criteria = response.data.rpg.criteria_old;
          this.text_info.criteria_gos = response.data.rpg.criteria_gos_old;
          this.text_info.literature_gos = response.data.rpg.literature_gos_old;
          this.text_info.literature = response.data.rpg.literature_old;
          this.text_info.preamble_comp = response.data.rpg.preamble_comp;
          this.resources = response.data.rpg.resources;
          this.data_bases = response.data.rpg.data_bases;
          this.discipline = response.data.rpg.discipline;
          this.actives_type = response.data.rpg.active_type;
        }).catch((error) => {
          return error;
        });
      }
    },
    getRPGSamples(){
      axios({
        method: 'get',
        url: `/programms/get_rpg_samples`,
      }).then((response) => {
        this.select_options.rpg_samples = response.data.samples
      }).catch((error) => {
        return error;
      });
    },
    PushToController (){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      if (this.main_info.doc_type === "ПРОГРАММА ИТОГОВОЙ АТЕСТАЦИИ"){
        axios({
          method: 'post',
          url: '/programms/rpg',
          data: {
            data: {
              curriculum_id: this.programm.curriculum,
              study_year_id: this.programm.year,
              educational_profile_id: this.programm.edu_prof,
              educational_programm_id: this.programm.edu_prog,
              name: this.main_info.doc_type,
              structure_old: this.text_info.structure,
              subject_old: this.text_info.subject,
              order_execution_old: this.text_info.order_execution,
              order_def_old: this.text_info.order_def,
              order_examination_old: this.text_info.order_examination,
              criteria_old: this.text_info.criteria,
              criteria_gos_old: this.text_info.criteria_gos,
              literature_gos_old: this.text_info.literature_gos,
              literature_old: this.text_info.literature,
              preamble_comp: this.text_info.preamble_comp,
              competition: this.rpg_competitions,
              software: this.software,
              resources: this.resources,
              data_bases: this.data_bases,
              discipline: this.discipline,
              main_info: this.main_info,
              active_type: this.actives_type,
              software_agreed: true,
              department_agreed: true,
              library_agreed: true,
            }
          }
        }).then((response) => {
          if (response.status === 200 || response.status === 204){
            location.assign('/programms/rpd')
          }
        }).catch((error) => {
          return error;
        });
      }
      else {
        axios({
          method: 'post',
          url: '/programms/rpg',
          data: {
            data: {
              curriculum_id: this.programm.curriculum,
              study_year_id: this.programm.year,
              educational_profile_id: this.programm.edu_prof,
              educational_programm_id: this.programm.edu_prog,
              name: this.main_info.doc_type,
              structure_old: this.text_info.structure,
              subject_old: this.text_info.subject,
              order_execution_old: this.text_info.order_execution,
              order_def_old: this.text_info.order_def,
              order_examination_old: this.text_info.order_examination,
              criteria_old: this.text_info.criteria,
              criteria_gos_old: this.text_info.criteria_gos,
              literature_gos_old: this.text_info.literature_gos,
              literature_old: this.text_info.literature,
              preamble_comp: this.text_info.preamble_comp,
              competition: this.rpg_competitions,
              software: this.software,
              resources: this.resources,
              data_bases: this.data_bases,
              discipline: this.discipline,
              main_info: this.main_info,
              active_type: this.actives_type,
            }
          }
        }).then((response) => {
          if (response.status === 200 || response.status === 204){
            location.assign('/programms/rpd')
          }
        }).catch((error) => {
          return error;
        });
      }
    },
  },
  mounted() {
    this.getEduProg()
    this.getYears()
    this.getSoftware()
    this.getRPGSamples()
  }
}
</script>

<style scoped>
  .vueditor {
    width: 100px;
    height: 450px;
    height: 100%;
    border: 1px solid #ddd;
    background: #fff;
    box-sizing: border-box;
    position: relative;
  }

  .verticalText
  {
    text-align: center;
    vertical-align: middle;
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    line-height: 1;
    width: 20px;
  }

  .headTable
  {
    text-align: center;
    vertical-align: top;
    overflow-wrap: break-word;
  }

  .headTableInt
  {
    text-align: center;
    vertical-align: top;
    overflow-wrap: break-word;
    word-wrap: break-word;
    width: 70px;
  }
</style>